const registry = new Map();

export function registerGame(definition) {
  if (!definition.slug) throw new Error('Game definition must have a slug');
  registry.set(definition.slug, definition);
}

export function getGame(slug) {
  return registry.get(slug) || null;
}

export function getAllGames() {
  return [...registry.values()];
}
